import { Button, Checkbox, Modal } from 'antd'
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react';
import { checkboxData, REQUIRED_COLUMNS } from '../../screens/EscalationCompleted/EscalationCompletedUtils';

export const EscalatedSelectedColumns = ({ open, setOpen, selectedColumns, setSelectedColumns, getRankingDataFun, defualtColumns, selectedMonth }) => {
    const [inputcolumns, setInputColumns] = useState([...selectedColumns]);

    useEffect(() => {
        setInputColumns([...selectedColumns])
    }, [open, selectedColumns])

    function onChangeFun(e, value) {
        if (e.target.checked) {
            setInputColumns((prev) => (value === 'all' ? [...defualtColumns, value] : [...prev, value]));
        } else {
            let arr = [...inputcolumns]
            const index = arr.indexOf(value);
            if (index > -1) {
                arr.splice(index, 1);
            }

            const indexall = arr.indexOf("all");
            if (indexall > -1) {
                arr.splice(indexall, 1);
            };

            setInputColumns(arr)
        }
    }

    function applyFun() {
        setOpen(false)
        setSelectedColumns([...inputcolumns])
        getRankingDataFun(selectedMonth)
    }

    function cancelFun() {
        setOpen(false)
        setSelectedColumns([...defualtColumns])
        getRankingDataFun(selectedMonth)
    }

    return (
        <Modal
            open={open}
            okText='Apply'
            cancelText='Clear All'
            onCancel={() => setOpen(false)}
            onOk={applyFun}
            footer={[
                <Button key="back" type='text' onClick={() => setOpen(false)}>
                    Cancel
                </Button>,
                <Button key="submit" type="default" onClick={cancelFun}>
                    Set Default
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={applyFun}
                >
                    Apply
                </Button>,
            ]}
        >
            <div style={{ padding: '25px' }}>
                <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                    <Title level={5}>Add Columns</Title>
                </div>
                {/* {checkboxData.reduce((rows, key, index) => (index % 2 === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows, []).map((row, rowIndex) => (
                    <div key={rowIndex} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                        {row.map(({ label, value }) => (
                            <div key={value} style={{ flex: 1 }}>
                                <Checkbox onChange={(e) => onChangeFun(e, value)} checked={inputcolumns.includes(value)}>
                                    {label}
                                </Checkbox>
                            </div>
                        ))}
                    </div>
                ))} */}
                {checkboxData
  .reduce((rows, key, index) => {
    if (index % 2 === 0) rows.push([key]);
    else rows[rows.length - 1].push(key);
    return rows;
  }, [])
  .map((row, rowIndex) => (
    <div
      key={rowIndex}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "10px"
      }}
    >
      {row.map(({ label, value }) => (
        <div key={value} style={{ flex: 1 }}>
          <Checkbox
            checked={inputcolumns.includes(value)}
            onChange={(e) => {
              if (REQUIRED_COLUMNS.includes(value)) {
                return; 
              }
              onChangeFun(e, value);
            }}
          >
            {label}
          </Checkbox>
        </div>
      ))}
    </div>
  ))}
            </div>
        </Modal>
    )
}
